import React, { useEffect, useState } from 'react';
import {Row, Table } from 'antd';
import getActivityRecordPromise from './promises/getActivityRecord';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

const ActivityModal = ({recordId}) => {
    const { t } = useTranslation();
    const [activities, setActivities] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true)
    getActivityRecords()
  }, []);

  const getActivityRecords = () => {
    getActivityRecordPromise(recordId).then((response) => {
        setActivities(response)
        setIsLoading(false)
    })
  }

    const activityColumns = [
        {
            title: t('messages.aml.date'),
            dataIndex:'dateShortAsString'
        },
        {
            title: t('messages.aml.user'),
            dataIndex:'userName'
        },
        {
            title: t('messages.aml.activity'),
            dataIndex:'text'
        },
        {
            title: t('messages.aml.comment'),
            dataIndex:'comment'
        },
    ]
    return (
        <Row gutter={[32, 12]}>
            <Table
                size='small'
                columns={activityColumns}
                dataSource={activities}
                loading={isLoading}
            />
        </Row>
    );
};

export default ActivityModal;